import type { DynamicFormSettings } from '../../@types/forms';
import i18next from '../../i18n';
import { aiApi } from '../../redux/services/ai-api';
import type { ImportFormBackgroundJobDetails } from '../../redux/slices/background-job-slice';
import { setBackgroundJobDetails } from '../../redux/slices/background-job-slice';
import { appDispatch } from '../../redux/store-accessors';
import { showError, showSuccess } from '../notification.service';
import { BackgroundJobHandler } from './background-job.handler';

export class ImportFormHandler extends BackgroundJobHandler<unknown> {
  constructor(details: ImportFormBackgroundJobDetails) {
    super(undefined, details);
  }

  public createBackgroundJob() {
    return Promise.resolve({ backgroundJobId: this.details!.backgroundJobId as number });
  }

  public getJobDetails(backgroundJobId: number) {
    const subscription = appDispatch(
      aiApi.endpoints.getImportFormJob.initiate(backgroundJobId, { forceRefetch: true })
    );
    return subscription.unwrap().finally(() => subscription.unsubscribe());
  }

  public successCallback(response: Record<string, unknown>) {
    return new Promise<void>((resolve, reject) => {
      const { result: formConfig } = response as { result: DynamicFormSettings };
      if (formConfig && this.details?.id) {
        appDispatch(setBackgroundJobDetails({ id: this.details.id as string, details: { formConfig } }));
        showSuccess(i18next.t('generate-form-success'));
        resolve();
      } else {
        showError(i18next.t('generate-form-failed'));
        reject(new Error('Form configuration is missing in the response'));
      }
    });
  }
}
